import React from "react";

import get from "lodash.get";
import { useSelector } from "react-redux";

import useAbility from "../../../hooks/useAbility";

import type { JSX, ReactNode } from "react";

import type { CanAccessReturn } from "../../../hooks/useAbility";
import type { AppState } from "../../../reducers";
import type { NestedKeys } from "../../../types/utils";

export type AbilityKey = NestedKeys<CanAccessReturn>;

interface AbilityContainerProps {
  children: ReactNode;
  abilityList: AbilityKey[] | undefined;
}

function AbilityContainer({
  children,
  abilityList,
}: AbilityContainerProps): JSX.Element | null {
  const orgaOptions = useSelector(
    (state: AppState) =>
      state.fetchReducer.orga_config.data?.organization_options,
  );
  const { canAccess } = useAbility();
  const hasAccess = canAccess(orgaOptions);
  const isAccessible =
    abilityList?.some((key) => get(hasAccess, key)) ?? !abilityList;

  return isAccessible ? <React.Fragment>{children}</React.Fragment> : null;
}

export default AbilityContainer;
